import React  from 'react'
import PropTypes from 'prop-types'
import styles from './FlowsListWrapper.module.scss'

const FlowsListWrapper = ({ children }) => (
  <nav className={styles.menu}>
    { children }
  </nav>
)

FlowsListWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired
}

export default FlowsListWrapper
